import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import classNames from 'classnames';
import { Theme } from 'styles/ThemeTyping';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CancelRoundedIcon from '@material-ui/icons/CancelRounded';

interface Props {
  everyoneSelected: boolean;
  disabled: boolean;
  onSetEveryoneSelected: (selected: boolean) => void;
}

function Empty({ everyoneSelected, disabled, onSetEveryoneSelected }: Props) {
  const classes = useStyles();

  return (
    <Box display="flex" alignItems="center">
      {everyoneSelected ? (
        <div className={classNames(classes.everyoneChip, disabled && classes.disabled)}>
          <IconButton onClick={() => onSetEveryoneSelected(false)} size="small" disabled={disabled}>
            <CancelRoundedIcon
              className={classNames(classes.deleteIcon, disabled && classes.disabled)}
            />
          </IconButton>
          Everyone
        </div>
      ) : (
        <Typography gutterBottom variant="body2">
          Select “Add Filter” to get started or click "Add Everyone" to add all available users. By
          default your role will have no assigned members.
        </Typography>
      )}
    </Box>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    color: theme.colors.gray2,
  },
  everyoneChip: {
    borderColor: 'rgba(0, 0, 0, 0.1)',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRadius: 4,
    padding: `${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
    paddingLeft: theme.spacing(0.25),
  },
  deleteIcon: { color: theme.palette.common.black },
  button: {
    textDecoration: 'underline',
    fontWeight: theme.typography.fontWeight.regular,
    padding: 0,
  },
  disabled: {
    color: theme.colors.gray2,
  },
}));

export default Empty;
